import React from "react";
import { useState, useEffect } from "react";



import axios from "axios";

import Card from "./Card";

import "../Styles/AdvancedSearch.css";

export default function AdvancedSearch() {
    const [ingredients, setIngredients] = useState([""]);
    const [tags, setTags] = useState([""]);
    const [categories, setCategories] = useState([]);
    const [recettes, setRecettes] = useState([]);
    const [searchTags, setSearchTags] = useState([]);

    useEffect(() => {
        axios.get("https://anatole-sot.xyz/api/recettes-gibli/get-categories.php")
        .then((response) => {
            if (response.data.status === "error") {
                alert(response.data.data);
                return;
            }
            setCategories(response.data.data);
        })
        .catch((error) => {
            console.log(error);
        })
        axios.get("https://anatole-sot.xyz/api/recettes-gibli/get-tags.php")
        .then((response) => {
            if (response.data.status === "error") {
                alert(response.data.data);
                return;
            }
            setTags(response.data.data);
        })
        .catch((error) => {
            console.log(error);
        })
    }, []);

    useEffect(() => {
        axios.get("https://anatole-sot.xyz/api/recettes-gibli/list-recipes.php")
        .then((response) => {
            if (response.data.status === "error") {
                alert(response.data.data);
                return;
            }
            setRecettes(response.data.data);
        })
        .catch((error) => {
            console.log(error);
        })
    }, []);


    function updateResults(e) {
        e.preventDefault();
        let params = {};
        if (ingredients.length > 0) {
            let filteredIngredients = [];
            for (let i = 0; i < ingredients.length; i++) {
                if (ingredients[i] !== "") filteredIngredients.push(ingredients[i]);
            }
            if (filteredIngredients.length > 0) params.ingredients = filteredIngredients.join(",");
        }
        if (searchTags.length > 0){
            let filteredTags = [];
            for (let i = 0; i < searchTags.length; i++) {
                if (searchTags[i] !== "") filteredTags.push(searchTags[i]);
            }
            if (filteredTags.length > 0) params.tags = filteredTags.join(",");
        };
        if (document.getElementById("time").value !== "") params.time = document.getElementById("time").value;
        if (document.getElementById("category").value !== "" && document.getElementById("category").value !== "0") params.category = document.getElementById("category").value;
        if (document.getElementById("people").value !== "") params.people = document.getElementById("people").value;
        if (document.getElementById("Title").value !== "") params.title = document.getElementById("Title").value;
        if (document.getElementById("generalSearch").value !== "") params.general = document.getElementById("generalSearch").value;
        axios.get("https://anatole-sot.xyz/api/recettes-gibli/advanced-search.php", {params: params})
        .then((response) => {
            if (response.data.status === "error") {
                alert(response.data.data);
                return;
            }
            setRecettes(response.data.data);
        })
        .catch((error) => {
            console.log(error);
        })
    }

    const addIngredient = (e) => {
        e.preventDefault();
        if (document.activeElement !== e.target) return;
        setIngredients([...ingredients, ""]);
    }

    function changeIngredient(e) {
        e = e.target;
        const index = e.dataset.index;
        if (ingredients[index] === e.value) return;
        ingredients[index] = e.value;
        setIngredients(ingredients);
    }

    function changeTag(e) {
        e = e.target.parentElement.parentElement.children;
        let out = [];
        for (let i = 0; i < e.length; i++) {
            if (e[i].firstChild.checked) {
                out.push(e[i].children[1].innerText);
            }
        }
        setSearchTags(out);
    }


    return (
        <div className="AdvancedSearch">
            <h2>Recherche Avancée</h2>
            <form onInput={updateResults}>
                <div className="generalSearch">
                    <label htmlFor="generalSearch">Recherche générale</label>
                    <input type="text" name="generalSearch" id="generalSearch" />
                </div>

                <div className="Title">
                    <label htmlFor="Title">Titre</label>
                    <input type="text" name="Title" id="Title" />
                </div>
                <div className="Tags">
                    <label htmlFor="Tags">Tags</label>
                    <ul>
                    {tags.map((tag, index) => {
                        return (
                            <li key={index}>
                                <input type="checkbox" name="tag" value={tag.ID} onChange={changeTag} data-index={index} />
                                <label htmlFor="tag">{tag.Name}</label>
                            </li>
                        );
                    })
                    }
                    </ul>
                </div>
                <div className="infos">
                    
                    <div>
                        <div>
                            <input type="number" id="time" name="time" required/>
                            <span className="emoji">(min)⏱️</span>
                        </div>
                    </div>
                    
                    <div>
                        <label htmlFor="category">Catégorie</label>
                        <select id="category" defaultValue="" name="category" required>
                            <option value="">Toutes les catégories</option>
                            {categories.map((category, index) => {
                                return (
                                    <option key={index} value={category.ID}>{category.Name}</option>
                                );
                            })
                            }
                        </select>
                    </div>
                    <div>
                        <div>
                            <input type="number" id="people" name="people" required/>
                            <span className="emoji">👤</span>
                        </div>
                    </div>
                    
                </div>
                <div className="ingrs">
                    <label htmlFor="ingredients">Ingrédients</label>
                    <ul>
                    {ingredients.map((ingredient, index) => {
                        return (
                            <li key={index}>
                                <input type="text" name="ingredient" defaultValue={ingredient} onChange={changeIngredient} data-index={index} required/>
                            </li>
                        );
                    })
                    }
                    </ul>
                    <button onClick={addIngredient}>Ajouter un ingrédient</button>
                </div>
            </form>
            <div className="results">
                {recettes.map((recette, index) => {
                    return (
                        <Card key={index} recette={recette} />
                    );
                })
                }
                {
                    recettes.length === 0 ? <p>Aucun résultat</p> : ""
                }
            </div>
        </div>
    );
}